export default __webpack_public_path__ + "static/media/stck.cf5d8d1f.jfif";